import firebase from 'firebase'
 var firebaseConfig = {
    apiKey: "AIzaSyBvlvu7wo5AgjHQkm1HLtQDL4rl5_3p-c0",
    authDomain: "educator-93566.firebaseapp.com",
    databaseURL: "https://educator-93566.firebaseio.com",
    projectId: "educator-93566",
    storageBucket: "educator-93566.appspot.com",
    messagingSenderId: "616930097324",
    appId: "1:616930097324:web:70ffb1dea9da7e69338709"
};

export default firebase.initializeApp(firebaseConfig);



// WEBPACK FOOTER //
// ./src/fireconfig.js